import React, { useMemo, useState } from 'react'
import { useAppSelector } from '../../../../../../../store/hooks'
import { selectCurrentUser } from '../../../../../../../store/meetingSummary/user'
import { Button } from '../../../../../../../components/Button/Button'
import './MeetingSummaryAgentCRMButton.scss'
import { AddAgentResultToCRMModal } from '../CRMModal/AddAgentResultToCRMModal'
import { selectRoomSession } from '../../../../../../../store/meetingSummary/roomSession'
import { selectMeetingSummarySyncStatus } from '../../../../../../../store/meetingSummaryAgent/meetingSummaryAgent'
import { formatDate } from '../../../../common/aifeatures/utils'
import { Tooltip } from '../../../../../../../components/Tooltip/Tooltip'
import { IntegrationIcon } from '../../../../../../../components/IntegrationIcon'
import { IntegrationServiceId } from '../../../../../../../common/integrations'

export const MeetingSummaryAgentCRMButton: React.FC<{
  serviceId: string
  label: string
}> = ({ serviceId, label }) => {
  const currentUser = useAppSelector(selectCurrentUser)
  const roomSession = useAppSelector(selectRoomSession)
  const meetingSummarySyncStatus = useAppSelector(selectMeetingSummarySyncStatus)
  const { integrations: currentUserIntegrations } = currentUser ?? {}

  const [show, setShow] = useState(false)
  const serviceSyncStatus = useMemo(() => {
    return meetingSummarySyncStatus.filter((status) => status.serviceId === serviceId)
  }, [serviceId, meetingSummarySyncStatus])
  const userHasCRMIntegration = currentUserIntegrations?.some(({ serviceId: sId }) => sId === serviceId)

  const getTooltipTitle = () => {
    const serviceIdLabel = serviceId[0].toUpperCase() + serviceId.slice(1)
    if (serviceSyncStatus.length > 0) {
      return `Saved 'Meeting Summary' to ${serviceIdLabel} on ${formatDate(serviceSyncStatus[serviceSyncStatus.length - 1].syncedAt)}`
    }
  }

  if (!userHasCRMIntegration || !roomSession) {
    return null
  }

  return (
    <>
      {show && <AddAgentResultToCRMModal roomSession={roomSession} show={show} onHide={() => setShow(false)} serviceId={serviceId} />}
      <Tooltip className='paragraph-small' title={getTooltipTitle()} placement='top' offset={[0, 10]} hidden={serviceSyncStatus.length === 0}>
        <Button className='px-2 py-1 button-medium' variant='header' onClick={() => setShow((show) => !show)}>
          <div className='d-flex gap-1 align-items-center'>
            <div className='d-flex position-relative'>
              <IntegrationIcon serviceId={serviceId as IntegrationServiceId} className='crm-icon' fill='var(--zocks-gray-900)' />
              <div>{serviceSyncStatus.length > 0 ? <i className='crm-synced-badge bi bi-circle-fill' /> : null}</div>
            </div>
            Save to {label}
          </div>
        </Button>
      </Tooltip>
    </>
  )
}
